<template>
  <div>
    <label v-if="!noLabel" class="teams-label-font"
      >{{ label }}<span v-if="mandatory" class="asterik">*</span></label
    >

    <div class="select-div" :ref="'multidrop' + id">
      <Popper
        trigger="clickToToggle"
        :key="'multidrop' + id"
        @show="openDropdown = true"
        @hide="openDropdown = false"
        :options="{
          preventOverflow: {
            enabled: true,
          },
          eventsEnabled: false,
        }"
      >
        <template slot="reference"
          ><div
            class="
              selectCustom-field
              d-flex
              align-items-center
              justify-content-between
            "
            :class="{ error: showError }"
            @focus="isFocused = true"
            @blur="isFocused = false"
            :style="
              id && id == 'kanbanpositionID' && 'height : 36px !important;'
            "
          >
            <span
              :class="
                selectedValues.length > 0
                  ? 'inputPlaceholder-font'
                  : 'input-empty-placeholder'
              "
            >
              {{
                selectedValues.length > 0
                  ? `${selectedValues.length}${
                      label ? " " + label : ""
                    } selected`
                  : placeholder
              }}
            </span>
            <img
              :class="openDropdown ? 'rotate180' : ''"
              class="access-validationicon-2"
              src="../../assets/cvsearch/cv-downarrow.svg"
              alt=""
            />
          </div>
        </template>
        <template class="popper">
          <div
            class="
              selectCustom-dropdown
              newManage-checkbox
              pff-checkbox
              newtp-checkbox
              customer-multi
            "
          >
            <b-form-checkbox-group
              :id="'multi-check' + id"
              v-model="selectedValues"
              :options="dropDownOptions"
              class="w-100 selectCustom-dropdown-innerContent"
              value-field="key"
              :disabled="disabled"
              text-field="label"
              disabled-field="notEnabled"
              @change="
                $emit('select-value', selectedValues), updateBackground()
              "
            ></b-form-checkbox-group>
          </div>
        </template>
      </Popper>
    </div>
    <!-- <div class="select-div"></div> -->
  </div>
</template>

<script>
import {
  getRequiredDocuments,
  getRbacDetails,
} from "../../utils/apiFunctions.js";
import { mapGetters } from "vuex";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  name: "MultiSelectCustom",
  components: {
    Popper,
  },
  props: {
    disabled: Boolean,
    noLabel: Boolean,
    mandatory: Boolean,
    showError: Boolean,
    dropdown: Boolean,
    label: String,
    placeholder: String,
    id: String,
    fieldType: String,
    api: String,
    values: Array,
    vmodel: {
      validator: function () {
        return true;
      },
    },
  },
  data() {
    return {
      openDropdown: false,
      dropDownOptions: [],
      selectedValues: [],
      apiFields: [
        "coOrdinators",
        "requiredDocumets",
        "buHead",
        "hiringManager",
      ],
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      licenseKey: "getlicenseKey",
    }),
  },
  watch: {
    // Follow the value when the form sets it after this field was created
    // (e.g. Upload JD fills the job form), like the other input components.
    // Our own selections come back as the same array, so they are skipped.
    vmodel(newVal) {
      if (!Array.isArray(newVal) || newVal === this.selectedValues) return;
      if (
        this.apiFields.includes(this.id) ||
        this.dropDownOptions.length === 0
      ) {
        this.selectedValues = [...newVal];
        return;
      }
      this.selectedValues = newVal.filter((value) =>
        this.dropDownOptions.some((option) => option.key === value)
      );
      if (this.selectedValues.length !== newVal.length)
        this.$emit("select-value", this.selectedValues);
    },
  },
  created() {
    if (this.dropdown) {
      this.dropDownOptions = this.values;
    } else {
      this.getDropdownOptions();
    }
    if (this.vmodel) {
      this.selectedValues = this.vmodel;
      if (!this.apiFields.includes(this.id)) {
        this.checkDefaultOption();
        this.selectedValues = this.selectedValues.filter((value) =>
          this.dropDownOptions.some((option) => option.key === value)
        );
      }
    } else {
      this.checkDefaultOption();
    }
  },
  methods: {
    onDropdownShow() {
      this.openDropdown = true;
      this.$nextTick(() => {
        this.updateBackground();
      });
    },
    onDropdownHide() {
      this.openDropdown = false;
    },
    handleKeydown(event) {
      if (event.key === "Tab") {
        this.openDropdown = false;
      }
    },
    checkDefaultOption() {
      if (this.dropdown) {
        const defaultOptions = this.dropDownOptions.filter(
          (option) => option.isDefault
        );
        defaultOptions.forEach((defaultOption) => {
          if (!this.selectedValues.includes(defaultOption.key)) {
            this.selectedValues.push(defaultOption.key);
          }
        });
        this.$emit("select-value", this.selectedValues);
      }
    },
    async getDropdownOptions() {
      if (this.fieldType == "default" || this.fieldType == "predefinedField") {
        if (this.id == "requiredDocumets") {
          const res = await getRequiredDocuments();
          this.dropDownOptions = res.data.data;
        } else if (
          this.id == "hiringManager" ||
          this.id == "buHead" ||
          this.id == "coOrdinators"
        ) {
          const payload = {
            project: "recruitment",
            licenseKey: this.licenseKey,
            searchQuery: "",
            roles:
              this.id == "coOrdinators"
                ? ["PUSH_JOB", "EXTERNAL_ACCESS"]
                : this.id == "buHead"
                ? ["VIEW_BUHEAD"]
                : ["VIEW_MANAGER"],
          };
          const res = await getRbacDetails(payload);
          const data = res.data.data;
          this.dropDownOptions = data.map((user) => ({
            key: user.userID,
            label: user.username,
          }));
        }
      }
    },
    updateBackground() {
      this.dropDownOptions.forEach((option, index) => {
        const checkbox = document.getElementById(
          `multi-check_BV_option_${index}`
        );
        if (checkbox) {
          const parentDiv = checkbox.closest(".custom-control");
          parentDiv.style.borderRadius = "0px";
          parentDiv.style.backgroundColor = checkbox.checked
            ? "#c8d9e5"
            : "#fff";

          if (!parentDiv.hoverListenersAdded) {
            parentDiv.addEventListener("mouseover", () => {
              if (!checkbox.checked) {
                parentDiv.style.backgroundColor = "#e8eff4";
              }
            });
            parentDiv.addEventListener("mouseout", () => {
              if (!checkbox.checked) {
                parentDiv.style.backgroundColor = "#fff";
              }
            });
            parentDiv.hoverListenersAdded = true;
          }
        }
      });
    },
  },
};
</script>

<style>
.multiselect-check .pff-checkbox .custom-control-label::after {
  top: 4px !important;
}
.customer-multi .custom-control-label::after {
  top: 4px !important;
}
</style>
